import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import AdminModuleDashboard from "./AdminDashboard.module";

export const AdminDashboardModuleRouteDef = makeObservableRouteDef({
  identifier: 'admin-dashboard',
  urlFactory: always('dashboard'),
  composeTitle: always('Dashboard'),
  component: AdminModuleDashboard,
})